const reducerName = '@cityoo-tenant/users';

export const RESET = `${reducerName}/RESET`;

export const SET_CURRENT_PAGE = `${reducerName}/SET_CURRENT_PAGE`;

export const GET_USERS_START = `${reducerName}/GET_USERS_START`;
export const GET_USERS_SUCCESS = `${reducerName}/GET_USERS_SUCCESS`;
export const GET_USERS_FAIL = `${reducerName}/GET_USERS_FAIL`;
